// Import dependencies
import React from 'react';
import axios from 'axios';
import cookie from 'js-cookie';
import { tokenize } from '../../../../helper';
import { FaTrashAlt, FaKey, FaPaperPlane } from 'react-icons/fa';
import { displayEmailVerified, navigateToMemberDetail } from '../uiAdminHelpers';
import { Modal, Button } from 'react-bootstrap';

// Import stlying
import { FaPlus } from 'react-icons/fa';
import './SpecialAccessPage.css';
import AdminNavbar from '../../../reusables/adminNavbar';

// Import config
import config from '../../../../configs/config.json';
const API_URL = config.API_URL;
const ADMIN_API_URL = API_URL + '/admin';
const AUTH_URL = config.AUTH_URL;

class SpecialAccessPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            members: [],
            selectedIndex: 0,
            stats: {
                daily: 0,
                monthly: 0,
                yearly: 0,
                total: 0,
            },
            parameters: {
                reverse: 0,
                page: 1,
                limit: 20,
                olli_member_id: null,
                device_type: null
            },
            newSpecialAccess: {
                id: 'Z',
                name: ''
            },
            showAddModal: false,
            addModalMessage: '',
            addModalAccessCodeError: false,
            addModalNameError: false,
            sortKey: 'NAMEASC'
        };
    }

    componentDidMount() {
        // As the component mounts, check if a token is already stored in the cookie
        var token = cookie.get('token');
        var user_type = cookie.get('user-type');
        if (token) {
            if (user_type === 'admin') {
                // Authorized as admin
                this.fetchMembers();
            } else {
                // Not authorized as admin, re-direct to log in page
                window.location.href = '/admin/';
            }
        } else {
            // No token found, re-direct to log in page
            window.location.href = '/admin/'
        }

    }

    fetchMembers = () => {
        // Make API request to back-end to fetch the current list of special access members;
        axios.get(`${ADMIN_API_URL}/special?sort=${this.state.sortKey}`, tokenize({ data: { parameters: this.state.parameters } }))
            .then(response => {
                console.log(response.data);
                this.setState({ members: response.data.members, stats: response.data.stats });
            })
            .catch(error => {
                console.log('Failed to retrieve members');
                console.log(error);
            })
    }

    handleSortRequest = (type) => {
        switch (type) {
            case 'name':
                (this.state.sortKey === 'NAMEASC') ? this.setState({ sortKey: 'NAMEDESC' }) : this.setState({ sortKey: 'NAMEASC' });
                break;
            case 'email':
                (this.state.sortKey === 'EMAILASC') ? this.setState({ sortKey: 'EMAILDESC' }) : this.setState({ sortKey: 'EMAILASC' });
                break;
            case 'emailVerified':
                (this.state.sortKey === 'EMAILVERIFIEDASC') ? this.setState({ sortKey: 'EMAILVERIFIEDDESC' }) : this.setState({ sortKey: 'EMAILVERIFIEDASC' });
                break;
            case 'id':
                (this.state.sortKey === 'IDASC') ? this.setState({ sortKey: 'IDDESC' }) : this.setState({ sortKey: 'IDASC' });
                break;
            case 'createdDate':
                (this.state.sortKey === 'REGISTEREDASC') ? this.setState({ sortKey: 'REGISTEREDDESC' }) : this.setState({ sortKey: 'REGISTEREDASC' });
                break;
            default:
                this.setState({ sortKey: 'NAMEASC' });
        }

        setTimeout(() => {
            this.fetchMembers();
        }, 100)

    }

    handleActionButtonClick = (index) => {
        // Select a member   
        this.setState({ selectedIndex: index });
    }

    confirmDelete = () => {
        // User has confirmed they want to delete a member, make the backend call to handle delete
        let dbMemberID = this.state.members[this.state.selectedIndex].ID; // SQL database member record ID

        axios.delete(`${ADMIN_API_URL}/members/${dbMemberID}`, tokenize())
            .then(result => {

                console.log(result.data);
                if (result.data.success) {
                    this.fetchMembers();
                    this.setState({
                        selectedIndex: 0
                    })
                }

            })
            .catch(error => {
                console.log(error);
            })
    }

    confirmResendEmailVerification = () => {
        let memberID = this.state.members[this.state.selectedIndex].ID; // SQL database member record ID

        axios.post(`${AUTH_URL}/verify/resend/${memberID}`)
            .then(result => {
                console.log(result.data);
                if (result.data.success) {
                    console.log('Successfully sent password reset email');
                }

            })
            .catch(error => {
                console.log(error);
            })
    }

    confirmPasswordReset = () => {
        // User has confirmed they want to send a password reset email to member, make the backend call to handle accordingly
        let memberEmail = this.state.members[this.state.selectedIndex].email; // SQL database member record ID
        // console.log("Send to: ", memberEmail);

        axios.post(`${AUTH_URL}/forgot`, { email: memberEmail })
            .then(result => {

                console.log(result.data);
                if (result.data.success) {
                    console.log('Successfully sent password reset email');
                }

            })
            .catch(error => {
                console.log(error);
            })
    }

    updateNewSpecialAccessForm = (fieldType) => (event) => {
        var newSpecialAccess = this.state.newSpecialAccess;
        if (fieldType === 'id') {
            // The affiliate number should only be a two digit code
            if (event.target.value.length < 10 && (event.target.value[0] === 'z' || event.target.value[0] === 'Z')) {
                newSpecialAccess[fieldType] = event.target.value;
                this.setState({ newSpecialAccess });
            }
        } else {
            newSpecialAccess[fieldType] = event.target.value;
            this.setState({ newSpecialAccess });
        }
    }

    closeAllModels = () => {
        this.setState({ showAddModal: false });
    }

    submitNewSpecialAccessForm = () => {
        console.log("Submit new special access form");
        var enteredId = this.state.newSpecialAccess.id;
        var enteredName = this.state.newSpecialAccess.name;

        if (enteredId[0] !== 'Z') {
            this.setState({ addModalAccessCodeError: true, addModalMessage: "First letter must be a Z." });
        } else if (enteredId.length !== 9) {
            this.setState({ addModalAccessCodeError: true, addModalMessage: "ID must be 9 letters/numbers in length beginning with Z." });
        } else if (enteredName === '') {
            this.setState({ addModalNameError: true, addModalMessage: "Please enter a name." });
        } else {
            console.log("Confirmed input")
            axios.post(`${ADMIN_API_URL}/special`, tokenize({ id: enteredId, name: enteredName }))
                .then(result => {
                    var payload = result.data;
                    if (payload.success) {
                        this.setState({
                            newSpecialAccess: {
                                id: 'Z',
                                name: ''
                            },
                            showAddModal: false,
                            addModalNameError: false,
                            addModalAccessCodeError: false,
                            addModalMessage: ''
                        });
                        setTimeout(() => window.location.href = '/admin/special', 500);
                    } else {
                        if (payload.accessCodeInUse) {
                            this.setState({ addModalAccessCodeError: true, addModalNameError: false, addModalMessage: "Special access code already in use." })
                        }
                    }

                })
                .catch(error => {
                    console.log(error);
                })
        }
    }

    render() {

        return (<div className="container-fluid">
            <AdminNavbar />

            <h1 className='pageTitle'>Special Access</h1>
            <p style={{ textAlign: 'center' }}>*Use <strong>CTR</strong> + <strong>F</strong> to search for member by name.</p>

            <div className='loginStatsContainer shadow-sm rounded mb-4'>
                <div>Daily {this.state.stats.daily}</div>
                <div>Monthly {this.state.stats.monthly}</div>
                <div>Yearly {this.state.stats.yearly}</div>
                <div>Total {this.state.stats.total}</div>
            </div>

            <table className='table table-striped generalTable loginHistoryTable shadow-sm rounded overflow-hidden mb-5'>
                <thead>
                    <tr>
                        <th className="border-0 align-middle d-none d-md-table-cell" onClick={() => this.handleSortRequest('name')}>Guest Name</th>
                        <th className="border-0 align-middle" onClick={() => this.handleSortRequest('email')}>Email</th>
                        <th className="border-0 align-middle" onClick={() => this.handleSortRequest('emailVerified')}>Verified</th>
                        <th className="border-0 align-middle d-none d-lg-table-cell" onClick={() => this.handleSortRequest('id')}>Special Access ID</th>
                        <th className="border-0 align-middle d-none d-lg-table-cell" onClick={() => this.handleSortRequest('createdDate')}>Creation Date</th>
                        <th className="border-0 align-middle d-none d-lg-table-cell" onClick={() => this.handleSortRequest('createdDate')}>Expiration Date</th>
                        <th className="border-0 align-middle"></th>
                        <th className="border-0 align-middle"><button className='btn btn-success' title='Add Special Access Code' data-toggle="modal" data-target="#addSpecialAccessModal" onClick={() => this.setState({ showAddModal: true })}><FaPlus /></button></th>
                    </tr>
                </thead>
                <tbody>
                    {

                        this.state.members.map((member, index) => {

                            var sqlMemberID = member.ID;
                            let expirationDate = new Date(member.member_since);
                            expirationDate.setDate(expirationDate.getDate() + 7);
                            expirationDate = expirationDate.toLocaleString();


                            return (<tr key={index}><td className="align-middle">{member.name}</td>
                                <td className="align-middle d-none d-md-table-cell" onClick={() => navigateToMemberDetail(sqlMemberID)}>{member.email}</td>
                                <td className="align-middle" onClick={() => navigateToMemberDetail(sqlMemberID)}>{displayEmailVerified(member.email_verified)}</td>
                                <td className="align-middle d-none d-lg-table-cell" onClick={() => navigateToMemberDetail(sqlMemberID)}>{member.olli_member_id}</td>
                                <td className="align-middle d-none d-lg-table-cell" onClick={() => navigateToMemberDetail(sqlMemberID)}>{member.member_since}</td>
                                <td className="align-middle d-none d-lg-table-cell" onClick={() => navigateToMemberDetail(sqlMemberID)}>{expirationDate}</td>
                                <td className="align-middle">
                                    {(member.email_verified) ?
                                        <button type='button' className='btn btn-secondary' title='Reset Password' data-toggle='modal' data-target='#resetPasswordModal' onClick={() => this.handleActionButtonClick(index)}><FaKey /></button>
                                        :
                                        (member.email) ?
                                            <button type='button' className='btn btn-warning' title='Resend Email Verification' data-toggle='modal' data-target='#resendEmailVerificationModal' onClick={() => this.handleActionButtonClick(index)}><FaPaperPlane /></button>
                                            :
                                            <button type='button' className='btn btn-warning' disabled title='User needs to register with an email address' data-toggle='modal' data-target='#resendEmailVerificationModal' onClick={() => this.handleActionButtonClick(index)}><FaPaperPlane /></button>
                                    }
                                </td>
                                <td className="align-middle"><button type='button' className='btn btn-danger' title='Delete Special Access' data-toggle='modal' data-target='#deleteMemberModal' onClick={() => this.handleActionButtonClick(index)}><FaTrashAlt /></button></td>
                            </tr>)

                        }) // End map function
                    }
                </tbody>
            </table>

            {/* Resend Email Verification Modal */}
            <div className="modal fade" id="resendEmailVerificationModal" tabIndex="-1" role="dialog" aria-labelledby="resendEmailVerificationModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="resendEmailVerificationModalLabel">Resend Email Verification</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            Resend email verification for {this.state.members.length !== 0 ? this.state.members[this.state.selectedIndex].email : ''}?
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal">Cancel</button>
                            <button type="button" className="btn btn-primary" data-dismiss="modal" onClick={this.confirmResendEmailVerification}>Resend</button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Reset Password Modal */}
            <div className="modal fade" id="resetPasswordModal" tabIndex="-1" role="dialog" aria-labelledby="resetPasswordModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="resetPasswordModalLabel">Reset Password</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            Send password reset for {this.state.members.length !== 0 ? this.state.members[this.state.selectedIndex].email : ''}?
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal">Cancel</button>
                            <button type="button" className="btn btn-primary" data-dismiss="modal" onClick={this.confirmPasswordReset}>Send</button>
                        </div>
                    </div>
                </div>
            </div>

            <Modal show={this.state.showAddModal} onHide={this.closeAllModels} >
                <Modal.Header closeButton>
                    <Modal.Title>Create Special Access ID</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <label htmlFor="formSpecialAccessCode">Special Access ID</label>
                    <input id='formSpecialAccessCode' className={(this.state.addModalAccessCodeError) ? 'form-control is-invalid' : 'form-control'} type='text' placeholder='Special Access ID' value={this.state.newSpecialAccess.id} onChange={this.updateNewSpecialAccessForm('id')} />

                    <label htmlFor="formGuestName">Guest Name</label>
                    <input id='formGuestName' className={(this.state.addModalNameError) ? 'form-control is-invalid' : 'form-control'} required type='text' placeholder='Guest Name' value={this.state.newSpecialAccess.name} onChange={this.updateNewSpecialAccessForm('name')} />

                    {(this.state.addModalMessage) ? <div style={{ marginTop: '1em' }} className='alert alert-danger'>{this.state.addModalMessage}</div> : ''}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={this.closeAllModels}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={this.submitNewSpecialAccessForm}>
                        Save Changes
                    </Button>
                </Modal.Footer>
            </Modal>


            {/* Delete Member Modal */}
            <div className="modal fade" id="deleteMemberModal" tabIndex="-1" role="dialog" aria-labelledby="deleteMemberModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="deleteMemberModalLabel">Delete Member</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            Are you sure you want to delete {this.state.members.length !== 0 ? this.state.members[this.state.selectedIndex].name : ''}?
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal">Cancel</button>
                            <button type="button" className="btn btn-danger" data-dismiss="modal" onClick={this.confirmDelete}>Delete</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>)
    }
}

export default SpecialAccessPage;